var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/components/feature/connections/NotForSale/DualHookShowcaseUpsell/ShowcaseMarkDownTextWithToolTip.jsx";

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Paragraph, TriggerText, Popper, Text, token } from '@zillow/constellation';
import marked from 'marked';
var StyledTriggerText = styled(TriggerText).withConfig({
  displayName: "ShowcaseMarkDownTextWithToolTip__StyledTriggerText",
  componentId: "sc-1x0o6z3-0"
})(["border:", ";color:", ";"], function (props) {
  return props.showTooltipTriggerUnderline ? "1px dotted " + token('colors.borderBlue') : 'none';
}, token('colors.borderBlue'));
var PopperDescriptionWrapper = styled.div.withConfig({
  displayName: "ShowcaseMarkDownTextWithToolTip__PopperDescriptionWrapper",
  componentId: "sc-1x0o6z3-1"
})(["line-height:1;"]);

var ShowcaseMarkDownTextWithToolTip = function ShowcaseMarkDownTextWithToolTip(_ref) {
  var markdownTextInput = _ref.markdownTextInput,
      bodyTooltipPopover = _ref.bodyTooltipPopover,
      fontType = _ref.fontType,
      showTooltipTriggerUnderline = _ref.showTooltipTriggerUnderline;
  // We divide the text into pre, popover text and post.
  var markdownTextParts = markdownTextInput.split(/{{(.+?)}}/g); // supports only 1 occurrence of {{}} hence the length check of 3

  if (markdownTextInput && bodyTooltipPopover && markdownTextParts.length === 3) {
    return /*#__PURE__*/React.createElement(PopperDescriptionWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(Text, {
      fontType: fontType,
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[0])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 29,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Text, {
      fontType: fontType,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 35,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(Popper, {
      triggered: bodyTooltipPopover,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 36,
        columnNumber: 21
      }
    }, /*#__PURE__*/React.createElement(StyledTriggerText, {
      showTooltipTriggerUnderline: showTooltipTriggerUnderline,
      fontType: fontType,
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[1])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 37,
        columnNumber: 25
      }
    }))), /*#__PURE__*/React.createElement(Text, {
      fontType: fontType,
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextParts[2])
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 17
      }
    }));
  } // If we cannot identify a substring surrounded by "{{}}" in the passed in markdowntext
  // then we return a vanilla markdown text field below (default case)


  if (markdownTextInput) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      fontType: fontType,
      dangerouslySetInnerHTML: {
        __html: marked.parseInline(markdownTextInput)
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 59,
        columnNumber: 13
      }
    });
  }

  return null;
};

ShowcaseMarkDownTextWithToolTip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The input text that could contain markdown. This text could optionally contain some
   * text within {{}} which is surrounded by the supplied popover element provided in the other
   * property [bodyToolTipPopover]
   */
  markdownTextInput: PropTypes.string,

  /**
   * The constructed popover that must be associated with the text within {{}}.
   * This is passed in externally to this component.
   */
  bodyTooltipPopover: PropTypes.element,
  fontType: PropTypes.string,

  /**
   * Optional boolean to show the blue dotted underline on tooltip trigger text.
   * Default is false
   */
  showTooltipTriggerUnderline: PropTypes.bool
} : {};
ShowcaseMarkDownTextWithToolTip.defaultProps = {
  markdownTextInput: '',
  bodyTooltipPopover: null,
  fontType: 'bodySmall',
  showTooltipTriggerUnderline: false
};
export { ShowcaseMarkDownTextWithToolTip };